export enum Notify {
  none,
  success,
  error,
  internalServerError
}
